import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCookie } from "utils/cookieUtils";
import { setLoading } from "reduxStore/slices/authSlice";
import Loader from "../common/Loader";
import { companyRegister } from "../../reduxStore/operations/authAPI";
import { Building } from "react-flaticons";

const SignUpWithGoogle = () => {
  const [errorMessages, setErrorMessages] = useState({});
  const [companyName, setCompanyName] = useState("");
  const [credential, setCredential] = useState("");

  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token) {
      navigate("/");
    }
  }, [navigate]);

  const handleCompanyRegister = (e) => {
    e.preventDefault();
    let errors = {};
    if (!companyName) {
      errors.companyName = "Company name is required.";
      setErrorMessages(errors);
      return;
    }
    const credential = localStorage.getItem("google_token");
    const isEmailSignUp = true;
    dispatch(setLoading(true));
    dispatch(
      companyRegister("", companyName, credential, "", navigate, isEmailSignUp)
    );
  };

  return (
    // <div className="flex flex-col gap-4 items-center justify-center min-h-screen bg-gray-100">
    //   <div className=" relative bg-white p-8 rounded shadow-md w-full max-w-sm">
    //     <div className="  absolute top-[-120px] right-0 w-full  flex items-center justify-center  ">
    //       <img
    //         src="/logo.png  "
    //         alt="logo"
    //         className=" w-0 h-0  xl:w-[200px] xl:h-[100px] "
    //       />{" "}
    //     </div>

    //     <h2 className="text-2xl mb-6 text-center">Welcome onboard!</h2>
    //     <form onSubmit={handleCompanyRegister}>
    //       {/* Email Field */}
    //       <div className="mb-32">
    //         <label className="block text-gray-700">Company</label>
    //         <input
    //           type="text"
    //           className={`w-full p-2 border ${
    //             errorMessages.companyName ? "border-red-500" : "border-gray-300"
    //           } rounded mt-1`}
    //           value={companyName}
    //           placeholder="Company"
    //           onChange={(e) => setCompanyName(e.target.value)}
    //         />
    //         {errorMessages.companyName && (
    //           <p className="text-red-500 text-sm mt-1">
    //             {errorMessages.companyName}
    //           </p>
    //         )}
    //       </div>
    //       <button
    //         type="submit"
    //         disabled={loading}
    //         className="w-full bg-blue-500 text-white p-2 rounded mt-4 hover:bg-blue-600"
    //       >
    //         {loading ? <Loader size="20" color="white" /> : "Take me in"}
    //       </button>
    //     </form>
    //   </div>
    // </div>
    <div className="h-screen flex flex-col  md:flex-row font-inter overflow-hidden ">
      <div className="w-full md:w-[60%] xl:w-[45%] max-w-[55rem] min-w-[24rem]  md:min-w-[32rem] flex flex-col items-center justify-center p-2 md:p-4">
        <div className="flex flex-col gap-8   justify-center  p-4 md:p-8  max-w-[30rem]">
          {/* <div className=" relative bg-white p-8 rounded shadow-md w-full max-w-sm"> */}
          <img
            src="/lane_icon_signin.svg"
            alt="logo"
            className="w-[125px] h-[75px] mr-auto"
          />

          <div>
            <h2 className="text-2xl text-left w-full mb-4 ">
              Welcome onboard!
            </h2>
            <p className=" text-[#696969] ">
              You're just a step away! Complete your details to get started.
            </p>
          </div>
          <form onSubmit={handleCompanyRegister}>
            {/* Email Field */}
            <div className="mb-10">
              {/* <label className="block text-gray-700">Company</label> */}
              <label className="block text-[16px] text-[#696969]">
                Company
              </label>
              {/* <input
                type="text"
                className={`w-full p-2 border ${
                  errorMessages.companyName
                    ? "border-red-500"
                    : "border-gray-300"
                } rounded mt-1`}
                value={companyName}
                // placeholder="Company"
                onChange={(e) => setCompanyName(e.target.value)}
              /> */}
              <div className="relative w-full">
                <Building
                  className="absolute left-3 top-[15px] text-gray-400"
                  size={18}
                />
                <input
                  type="text"
                  className={`w-full p-2 pl-10 border ${
                    errorMessages.companyName
                      ? "border-red-500"
                      : "border-gray-300"
                  } rounded mt-1`}
                  value={companyName}
                  // placeholder="Company"
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>
              {errorMessages.companyName && (
                <p className="text-red-500 text-sm mt-1">
                  {errorMessages.companyName}
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full font-bold  bg-signup-button text-white p-2 rounded hover:bg-blue-600"
            >
              {loading ? <Loader size="20" color="white" /> : "Take me in"}
            </button>
          </form>
          {/* </div> */}
        </div>
      </div>
      <div className="hidden md:block bg-[#F9FBFC] md:w-[40%] xl:w-[55%] relative pl-[6rem]">
        {/* Quote */}
        <h2 className="pt-[64px] pr-0 md:pr-[7rem]  md:text-[17px] lg:text-[24px]  xl:text-[28px]  text-gray-800">
          “A study across 181 companies found that the average core feature
          adoption rate is 24.5%”
        </h2>

        {/* Background Image */}
        <div className="absolute top-[14rem] left-[6rem] bottom-0 border  rounded-xl overflow-hidden">
          <img
            src="/signup3-cropped.svg"
            alt="Background"
            className="w-full xl:min-w-[60rem] h-full object-cover"
            style={{
              objectPosition: "top left", // Align the image to the top-left corner
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SignUpWithGoogle;
